export const PRODUCTION_STATUSES = ["NEW", "EDITING", "READY", "DELIVERED"];

export const STATUS_META = {
  NEW: { label: "New", accent: "#94A3B8", chip: "bg-slate-500/10 text-slate-700 border-slate-500/25 dark:bg-slate-500/15 dark:text-slate-200 dark:border-slate-500/30", wip: 12 },
  EDITING: { label: "Editing", accent: "#A855F7", chip: "bg-purple-500/10 text-purple-700 border-purple-500/25 dark:bg-purple-500/15 dark:text-purple-200 dark:border-purple-500/30", wip: 10 },
  READY: { label: "Ready", accent: "#F59E0B", chip: "bg-amber-500/10 text-amber-700 border-amber-500/25 dark:bg-amber-500/15 dark:text-amber-200 dark:border-amber-500/30", wip: 12 },
  DELIVERED: { label: "Delivered", accent: "#10B981", chip: "bg-emerald-500/10 text-emerald-700 border-emerald-500/25 dark:bg-emerald-500/15 dark:text-emerald-200 dark:border-emerald-500/30", wip: 999 },
};

export const DELIVERABLE_META = {
  "Video": "bg-rose-500/10 text-rose-700 border-rose-500/25 dark:bg-rose-500/15 dark:text-rose-200 dark:border-rose-500/30",
  "Social Reels": "bg-fuchsia-500/10 text-fuchsia-700 border-fuchsia-500/25 dark:bg-fuchsia-500/15 dark:text-fuchsia-200 dark:border-fuchsia-500/30",
  "Floor Plans": "bg-cyan-500/10 text-cyan-700 border-cyan-500/25 dark:bg-cyan-500/15 dark:text-cyan-200 dark:border-cyan-500/30",
  "3D Tours": "bg-indigo-500/10 text-indigo-700 border-indigo-500/25 dark:bg-indigo-500/15 dark:text-indigo-200 dark:border-indigo-500/30",
  "Photo to Video": "bg-orange-500/10 text-orange-700 border-orange-500/25 dark:bg-orange-500/15 dark:text-orange-200 dark:border-orange-500/30",
  "Aerial Videos": "bg-sky-500/10 text-sky-700 border-sky-500/25 dark:bg-sky-500/15 dark:text-sky-200 dark:border-sky-500/30",
  "Aerial Photos": "bg-teal-500/10 text-teal-700 border-teal-500/25 dark:bg-teal-500/15 dark:text-teal-200 dark:border-teal-500/30",
  "Photo Edits": "bg-violet-500/10 text-violet-700 border-violet-500/25 dark:bg-violet-500/15 dark:text-violet-200 dark:border-violet-500/30",
  "Photos": "bg-blue-500/10 text-blue-700 border-blue-500/25 dark:bg-blue-500/15 dark:text-blue-200 dark:border-blue-500/30",
  "Other": "bg-slate-500/10 text-slate-700 border-slate-500/25 dark:bg-slate-500/15 dark:text-slate-200 dark:border-slate-500/30",
};

export const DELIVERABLE_STATUS_META = {
  NEW: { label: "New", chip: "bg-slate-500/10 text-slate-700 border-slate-500/25 dark:bg-slate-500/15 dark:text-slate-200 dark:border-slate-500/30" },
  EDITING: { label: "Editing", chip: "bg-purple-500/10 text-purple-700 border-purple-500/25 dark:bg-purple-500/15 dark:text-purple-200 dark:border-purple-500/30" },
  READY: { label: "Ready", chip: "bg-amber-500/10 text-amber-700 border-amber-500/25 dark:bg-amber-500/15 dark:text-amber-200 dark:border-amber-500/30" },
  DELIVERED: { label: "Delivered", chip: "bg-emerald-500/10 text-emerald-700 border-emerald-500/25 dark:bg-emerald-500/15 dark:text-emerald-200 dark:border-emerald-500/30" },
};

export const DELIVERABLE_STATUSES = ["NEW", "EDITING", "READY", "DELIVERED"];

export const PAYMENT_META = {
  PAID: "bg-emerald-500/10 text-emerald-700 border-emerald-500/25 dark:bg-emerald-500/15 dark:text-emerald-200 dark:border-emerald-500/30",
  PARTIALLY_PAID: "bg-amber-500/10 text-amber-700 border-amber-500/25 dark:bg-amber-500/15 dark:text-amber-200 dark:border-amber-500/30",
  UNPAID: "bg-rose-500/10 text-rose-700 border-rose-500/25 dark:bg-rose-500/15 dark:text-rose-200 dark:border-rose-500/30",
};

export function formatCurrency(cents, currency = "USD") {
  const val = (cents || 0) / 100;
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency, maximumFractionDigits: 0 }).format(val);
  } catch {
    return `$${val.toFixed(0)}`;
  }
}

let APP_TZ = undefined; // undefined => browser local

export function setAppTimezone(tz) {
  APP_TZ = tz || undefined;
}

export function getAppTimezone() {
  return APP_TZ;
}

function isDateOnly(s) {
  return typeof s === "string" && s.length === 10 && !s.includes("T");
}

export function formatDate(iso) {
  if (!iso) return "—";
  try {
    if (isDateOnly(iso)) {
      const [y, m, d] = iso.split("-").map(Number);
      return new Date(y, m - 1, d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
    }
    return new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: APP_TZ });
  } catch {
    return "—";
  }
}

export function formatDateTime(iso) {
  if (!iso) return null;
  try {
    return new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "numeric", minute: "2-digit", timeZone: APP_TZ });
  } catch {
    return null;
  }
}

export function formatTime(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", timeZone: APP_TZ });
  } catch {
    return "";
  }
}

// "1h 23m", "5m", "0m" — compact tracked-time label
export function formatDuration(totalSeconds) {
  const raw = Math.floor(totalSeconds || 0);
  const sign = raw < 0 ? "-" : "";
  const s = Math.abs(raw);
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  if (h > 0) return `${sign}${h}h ${m}m`;
  if (m > 0) return `${sign}${m}m`;
  return `${sign}${s}s`;
}

// "01:23:45" / "23:45" — live counting clock for the floating timer
export function formatClock(totalSeconds) {
  const s = Math.max(0, Math.floor(totalSeconds || 0));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(sec)}` : `${pad(m)}:${pad(sec)}`;
}


export function formatDayLabel(dateStr, opts = { weekday: "long", month: "long", day: "numeric" }) {
  if (!dateStr) return "";
  try {
    if (isDateOnly(dateStr)) {
      const [y, m, d] = dateStr.split("-").map(Number);
      return new Date(y, m - 1, d).toLocaleDateString("en-US", opts);
    }
    return new Date(dateStr).toLocaleDateString("en-US", { ...opts, timeZone: APP_TZ });
  } catch {
    return dateStr;
  }
}

// Relative due label, e.g. "Due today", "Due tomorrow", "Due in 3 days",
// "Due yesterday", "3 days overdue". Hover shows the actual date (formatDate).
export function relativeDue(dateStr) {
  if (!dateStr) return "No due date";
  try {
    let y, m, d;
    if (isDateOnly(dateStr)) {
      [y, m, d] = dateStr.split("-").map(Number);
    } else {
      const dt = new Date(dateStr);
      y = dt.getFullYear(); m = dt.getMonth() + 1; d = dt.getDate();
    }
    const due = new Date(y, m - 1, d);
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const diff = Math.round((due - today) / 86400000);
    if (diff === 0) return "Due today";
    if (diff === 1) return "Due tomorrow";
    if (diff === -1) return "Due yesterday";
    if (diff > 1) return `Due in ${diff} days`;
    return `${Math.abs(diff)} days overdue`;
  } catch {
    return "—";
  }
}


export const SORT_OPTIONS = [
  { value: "shoot_asc", label: "Shoot date (soonest)" },
  { value: "shoot_desc", label: "Shoot date (latest)" },
  { value: "created_desc", label: "Recently placed" },
  { value: "total_desc", label: "Highest value" },
];

export const TEMPLATE_TAGS = [
  { tag: "{{street_address}}", label: "Street address", example: "1402 Bern Dr" },
  { tag: "{{city_state_zip}}", label: "City, State ZIP", example: "Spring Hill, TN 37174" },
  { tag: "{{client_name}}", label: "Client name", example: "Amy Nease" },
  { tag: "{{client_phone}}", label: "Client phone", example: "(615) 555-0142" },
];

export function fillTemplate(body, order) {
  if (!body) return "";
  const full = order.address || "";
  const street = order.street_address || full.split(",")[0] || "";
  const csz = order.city_state_zip || full.split(",").slice(1).join(",").trim() || "";
  return body
    .split("{{street_address}}").join(street)
    .split("{{city_state_zip}}").join(csz)
    .split("{{client_name}}").join(order.client_name || "")
    .split("{{client_phone}}").join(order.client_phone || "");
}

